import XLSX from 'xlsx';
import store from '@/store/store'

const buildData = data => {

  return new Promise((resolve, reject) => {

    // �������е��Y�ϕ������@
    let arrayData = [];

    // ȡ data �ĵ�һ�� Object �� key �����^
    let arrayTitle = Object.keys(data[0]);
    arrayData.push(arrayTitle);

    // ȡ��ÿһ�� Object �e�� value��push �M�µ� Array �e
    Array.prototype.forEach.call(data, d => {
      let items = [];
      Array.prototype.forEach.call(arrayTitle, title => {
        let item = d[title] || '�o';
        items.push(item);
      });
      arrayData.push(items)
    })

    resolve(arrayData);
  })
}

const downloadCSV = (fileName,data) => {
  let csvContent = '';
  Array.prototype.forEach.call(data, d => {
    let dataString = d.join(',') + '\n';
    csvContent += dataString;
  })

  // ����һ�� a���K�c����
  let link = document.createElement('a');
  link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csvContent));
  link.setAttribute('download', fileName);
  link.click();
}

const readXLSX = function readXLSX(file) {
  let nameSplit = file.name.split(".");
  let format = nameSplit[nameSplit.length - 1];
  if (!["xlsx", "xls", "csv"].includes(format)) {
    return false;
  }
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.readAsBinaryString(file.raw);
    reader.onload = evt => {
      let data = evt.target.result; // 读到的数据
      let workbook = XLSX.read(data, {type: "binary"});
      resolve(workbook);
    };
  });
}

/*
* 字典表中取出数据 string 转 int
* */
const dictDataStringToInt = (list) => {
  let data = []
  if (!_.isEmpty(list)) {
    data = list.map(x => {
      return {
        key: x.key != '' ? parseInt(x.key) : -1, // すぺて
        value: x.value
      }
    })
  }
  return data
}

var formatMoney = function(val) {
  if (!val) return '0.00'
  val = val.toFixed(2)
  const intPart = Math.trunc(val)
  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  let floatPart = '.00'
  const newArr = val.toString().split('.')
  if (newArr.length === 2) {
    floatPart = newArr[1].toString()
    return intPartFormat + '.' + floatPart
  }
  return intPartFormat + floatPart
}

var delcommafy = function(num) {
  if(!num) return num;
  num = num.toString();
  num = num.replace(/,/gi, '');
  if (num.indexOf('.00') > 0) num = parseInt(num);
  return num;
}

//define(function(){
var str2UTF8 = function (str) {
  var bytes = new Array();
  var len, c;
  len = str.length;
  for (var i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if (c >= 0x010000 && c <= 0x10FFFF) {
      bytes.push(((c >> 18) & 0x07) | 0xF0);
      bytes.push(((c >> 12) & 0x3F) | 0x80);
      bytes.push(((c >> 6) & 0x3F) | 0x80);
      bytes.push((c & 0x3F) | 0x80);
    } else if (c >= 0x000800 && c <= 0x00FFFF) {
      bytes.push(((c >> 12) & 0x0F) | 0xE0);
      bytes.push(((c >> 6) & 0x3F) | 0x80);
      bytes.push((c & 0x3F) | 0x80);
    } else if (c >= 0x000080 && c <= 0x0007FF) {
      bytes.push(((c >> 6) & 0x1F) | 0xC0);
      bytes.push((c & 0x3F) | 0x80);
    } else {
      bytes.push(c & 0xFF);
    }
  }
  return bytes;
}

var setRoute = function formatRoute(aRouter, routeMapList) {
  for (var i = 0; i < routeMapList.length; i++) {
    var routeMap = routeMapList[i];
    if (routeMap.children.length > 0) {
      routeChild = []
      formatRoute(routeChild, routeMap.children);
      var oRouter = {
        path: routeMap.serverUrl
        , name: routeMap.componentNm
        , component: (resolve) => require(['@/' + routeMap.componentUrl], resolve)
        , children: routeChild
        , meta: {name: routeMap.moduleNm, breadCrumbLv: routeMap.breadCrumbLv}
      }

      aRouter.push(oRouter);
    } else {
      var oRouter = {
        path: routeMap.serverUrl
        , name: routeMap.componentNm
        , component: (resolve) => require(['@/' + routeMap.componentUrl], resolve)
        , meta: {name: routeMap.moduleNm, breadCrumbLv: routeMap.breadCrumbLv}
      }
      aRouter.push(oRouter);
    }
  }
  return;
}

var setRoute2 = function formatRoutes(routes) {
  const fmRoutes = []
  routes.forEach(router => {
    router.component = resolve => {
      require(['@/' + router.componentUrl + '.vue'], resolve)
    }
    router.path = router.serverUrl
    router.name = router.componentNm
    let keepAlive = false
    if (router.name === 'CustomerOverview' || router.name === 'CustCpanyOverview') {
      keepAlive = true
    }
    router.meta = {name: router.moduleNm, breadCrumbLv: router.breadCrumbLv, keepAlive: keepAlive, isBack: false}
    router.props = true
    let children = router.children
    if (children && children instanceof Array) {
      children = formatRoutes(children)
    }

    router.children = children

    fmRoutes.push(router)
  })
  return fmRoutes;
}

var hasPermission = function hasPermission(funcCd) {
  if (funcCd == undefined || funcCd == null || funcCd.length == 0) {
    return false;
  }
  let isExist = false;
  let funcList = store.state.loginUser.funcList;
  if (funcList.filter(x => x.funcCd == funcCd).length > 0) {
    isExist = true;
  }
  return isExist;
}

var pickerOptions = {
  shortcuts: [{
    text: '今天',
    onClick(picker) {
      picker.$emit('pick', new Date());
    }
  }, {
    text: '昨天',
    onClick(picker) {
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24);
      picker.$emit('pick', date);
    }
  }, {
    text: '一周前',
    onClick(picker) {
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', date);
    }
  }, {
    text: '半月前',
    onClick(picker) {
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 15);
      picker.$emit('pick', date);
    }
  }]
}

var pickerBlur = function(val) {
	let date = ''
	let arr = []
	if (!_.isEmpty(val)) {
		arr = val.split("-")
	}
	if (arr.length != 3) {
		date = ''
	} else {
		if (arr[0].length == 4) {
			if (arr[1].length == 1) {
				arr[1] = '0' + arr[1]
			}
			if (arr[2].length == 1) {
				arr[2] = '0' + arr[2]
			}
			date = arr[0] + '-' + arr[1] + '-' + arr[2]
		} else {
			date = ''
		}
	}
	return date
}

var yearSwitch = function() {
	const now = new Date();
	return now.gerMgetMonth >= 3;
}

export default {yearSwitch, formatMoney, delcommafy, str2UTF8, readXLSX, setRoute, setRoute2, hasPermission, downloadCSV, buildData, pickerOptions, dictDataStringToInt, pickerBlur};
